<template>
  <div class="home">

    <div>
      <div class="header_desktop row">
        <div class="div_arret col-7">
          <h1>Arrêt: {{ this.$route.params.stopName }}</h1>
        </div>
        <div class="div_img col-5">
          <a href="https://www.reseau-colibri.fr">
            <img class="logo_desktop" src="../assets/logo.png" alt="logo colibri"/>
          </a>
        </div>
      </div>

      <div class="header_mobile row">
        <div class="col-12">
          <a href="https://www.reseau-colibri.fr">
            <img class="logo_mobile" src="../assets/logo.png" alt="logo colibri"/>
          </a>
        </div>
        <div class="col-12">
          <h1>Arrêt: {{this.$route.params.stopName }}</h1>
        </div>
      </div>
    </div>

    <div class="tableau">
      <div class="haut_tableau row">
        <div class="ligne col-xl-2 col-sm-3 col-3">
          <span>LIGNE</span>
        </div>
        <div class="destination col-xl-6 col-sm-7 col-5">
          <span>DESTINATION</span>
        </div>
        <div class="prochain col-xl-4 col-sm-2 col-4">
          <span>PROCHAIN DEPART</span>
        </div>
      </div>

      <div v-if="passage.stop_depasse === false" :key="passage.trip_id" :style="listPair(index)" class="bus row" v-for="(passage, index) in passages">
        <div :style="{ backgroundColor: '#' + passage.route_color }" class="ligne col-xl-2 col-sm-3 col-3">
          <span :style="{ color: '#' + passage.route_text_color, textAlign: 'center' }">{{ formatId(passage.route_id) }}</span>
        </div>
        <div class="destination row col-xl-4 col-sm-5 col-5">
          <span class="col-12">{{ passage.headsign }}</span>
          <router-link v-if="passage.vehicule_short_id !== 'null'" class="detail_vehicule col-12"
                       :to="{name:'detailBus', params: {stopId: passage.stop_id, tripId: passage.trip_id, numSequence: passage.sequence}}">
            <span style="white-space: nowrap;">Suivre le bus <i class="fas fa-chevron-right"></i></span>
          </router-link>
        </div>

        <div class="prochain col-xl-4 col-sm-2 col-4" v-if="passage.horaire_arrive_reel !== null">
          <span :style="{fontWeight: 'bold'}">Départ immédiat</span>
        </div>

        <div class="prochain col-xl-6 col-sm-4 col-4" style="flex-flow: column;"
             v-else-if="passage.horaire_arrive_estimee !== null">
          <span>{{ passage.horaire_arrive_estimee | filtreTemps }}</span>
          <span
            style="font-size: 0.6em; color: #F08100;">{{
              afficherRetard(passage.horaire_arrive_estimee, passage.horaire_arrive_prevu)
            }}</span>
        </div>

        <div class="prochain col-xl-6 col-sm-4 col-4" v-else>
          <span>{{ passage.horaire_arrive_prevu | filtreTemps }}</span>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import moment from 'moment'
  import router from '../router'

  export default {
    name: 'Home',
    data () {
      return {
        arret: null,
        passages: null,
        timer: ''
      }
    },
    methods: {
      formatId(id) {
        if (!id) {
          return '';
        }

        if (/^15LE\d+/.test(id)) {
          const match = id.match(/^15L(E\d+)/);
          return match ? match[1] : id;
        }

        const match = id.match(/^15L(\d+)/);
        return match ? match[1] : id;
      },
      listPair: function (cases) {
        let style = {}
        if (cases % 2 !== 0) {
          style.backgroundColor = '#e7f5f8'
        }
        return style
      },
      affichetrajet: function () {
        this.axios
          .get('/prochains-passages/' + this.$route.params.stopName)
          .then((succes) => {
            this.passages = succes.data
          }, (error) => {
            console.error('ERREUR de routes pour les trajets', error)
          })
      },
      afficherRetard: function (estimee, prevue) {
        moment.locale('fr')
        console.log(estimee)
        console.log(prevue)
        let diff = moment(estimee).diff(moment(prevue), 'minutes')
        console.log(diff)
        if (diff > 1) {
          return 'retard : ' + diff + ' min'
        } else {
          return ''
        }
      }
    },

    mounted () {
      this.affichetrajet()
      this.timer = setInterval(this.affichetrajet, 60000)
      moment.updateLocale('fr', {
        relativeTime: {
          m: '%dmin',
          mm: '%dmin'
        }
      })
      router.beforeEach((to, from, next) => {
        clearInterval(this.timer)
        next()
      })
    },

    filters: {
      filtreTemps: function (horraireArrivee) {
        let date = moment(horraireArrivee)
        moment.locale('fr')
        if (date < moment().add(1, 'minute')) {
          return 'Imminent'
        } else if (date < moment().add(44, 'minute')) {
          return moment(horraireArrivee).fromNow('m')
        } else if (date < moment().endOf('day')) {
          return (moment(horraireArrivee).format('HH') + 'h' + moment(horraireArrivee).format('mm'))
        } else {
          return moment(horraireArrivee).format('DD/MM à HH') + 'h' + moment(horraireArrivee).format('mm')
        }
      }
    }
  }
</script>

<style scoped lang="scss">
@import "../sass/variables";
@import "../../node_modules/bootstrap/scss/bootstrap";

.parent {
  display: table-cell;
  vertical-align: middle;
}

.home {
  .header_desktop {
    @include media-breakpoint-down(sm) {
      display: none;
    }
    margin: 4% 5rem -2% 5rem;

    .div_arret {
      display: flex;

      h1 {
        @include media-breakpoint-up(xl) {
          font-size: 4rem;
        }
        color: $firstcolor;
        font-family: $titlefont;
        font-weight: bold;
        margin-bottom: auto;
        margin-top: auto;
      }
    }

    .div_img {
      display: flex;

      a {
        margin: auto;

        .logo_desktop {
          width: 100%;
          float: right;
        }
      }
    }
  }

  .header_mobile {
    margin: auto;
    text-align: center;
    @include media-breakpoint-up(md) {
      display: none;
    }

    .logo_mobile {
      width: 75%;
    }

    h1 {
      color: $firstcolor;
      font-family: $titlefont;
      font-weight: bold;
      margin-top: auto;
      margin-bottom: auto;
    }
  }

  .tableau {
    @include media-breakpoint-down(sm) {
      padding: 1rem;
    }
    padding: 3rem 5rem 5rem 5rem;
    width: 100%;

    .haut_tableau {
      background-color: $firstcolor;
      color: white;

      .ligne, .destination, .prochain {
        border: 0;
        background-color: $firstcolor;

        span {
          margin-top: auto;
          margin-bottom: auto;
        }
      }

      .ligne, .destination {
        @include media-breakpoint-up(lg) {
          font-size: 3.5rem;
        }
        font-size: 1.1rem;
        font-family: $titlefont;
        font-weight: bold;
      }

      .prochain {
        @include media-breakpoint-up(lg) {
          font-size: 1.65rem
        }
        font-size: 15px;
        font-family: $titlefont;
        line-height: 100%;
      }
    }

    .ligne {
      @include media-breakpoint-up(lg) {
        font-size: 2.5rem;
      }
      font-family: $titlefont;
      font-weight: bold;
      border-top: 1px solid white;
      padding: 10px;
      display: flex;

      span {
        margin: auto;
      }
    }

    .destination {
      @include media-breakpoint-up(lg) {
        padding-left: 5rem;
        font-size: 2.5rem;
      }
      padding-top: 10px;
      padding-bottom: 10px;
      font-family: $textfont;
      text-align: left;
      display: flex;

      span {
        margin: auto 0;
      }

      .liens {
        text-decoration: none;
        color: black;
        display: flex;

        span {
          margin: auto;
        }
      }

      .detail_vehicule {
        margin: auto;
        font-size: 18px;
        text-decoration: none;
        color: $annexecolor;
      }
    }

    .prochain {
      @include media-breakpoint-up(lg) {
        font-size: 1.85rem;
      }
      @include media-breakpoint-up(xl) {
        font-size: 2.4rem;
      }
      margin-left: auto;
      font-family: $textfont;
      display: flex;
      padding: 10px;
      border-bottom: 1px solid white;

      span {
        width: 100%;
        text-align: end;
        margin: auto;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue